import React, {useEffect, useState} from "react";
import {signOut} from 'aws-amplify/auth';
import libToast from "../lib/LibToast";
import UrlPage from "../UrlPage";
import {useNavigate} from "react-router-dom";
import * as PropTypes from "prop-types";

const isMobile = window.innerWidth < 720;


const attMenuList = [
  {label: "Inicio", urlRel: UrlPage.home, icon: "fa fa-home"},
  {label: "Estudios", urlRel: UrlPage.estudios, icon: "fa fa-files-o"},

];

function MenuDesktop(props) {
  
  const navigate = useNavigate();
  const menuList = props.attMenuList.map(k => {
    const css = k.urlRel === props.urlPage ? "navbar-item selected" : "navbar-item";
    
    return (
      <div className={css} key={k.urlRel}>
        <span onClick={() => navigate(k.urlRel)}>
          <i className={k.icon + " m5R"}/>
          {k.label}
        </span>
      </div>
    );
  })
  
  return <div className="divFlex mainMenuDesk ">
    {menuList}
    <div className="flexGrow1"></div>
    <div className="navbar-item  itemNombreCliente">
            <span>
              <i className="fa fa-user m5R"/>
              {props.nombre} / {props.empresa}</span>
    </div>
    <div className="navbar-item " onClick={props.onClick}>
            
            <span>
              <i className="fa fa-sign-out m5R"></i>
            Salir</span></div>
  </div>;
}

MenuDesktop.propTypes = {
  menuList: PropTypes.arrayOf(PropTypes.any),
  nombre: PropTypes.any,
  empresa: PropTypes.any,
  onClick: PropTypes.func
};

function MenuMobile(props) {
  const navigate = useNavigate();
  
  const menuList = props.attMenuList.map(k => {
    const isSel = k.urlRel === props.urlPage;
    
    return isSel
      ? <option value={k.urlRel} key={k.label}>{k.label}</option>
      : <option value={k.urlRel} key={k.label} selected>{k.label}</option>
      ;
  })
  
  const onChange = (event) => {
    const value = event.target.value;
    if (value === "salir") {
      props.onClick();
    } else {
      navigate(value);
    }
  }
  
  //<option value="/cuenta">Cuenta</option>
  
  
  return (
    <div style={{flexGrow: 1, marginLeft: "20px", paddingTop: "14px", fontSize: "19px"}}>
      
      <select defaultValue={props.urlPage === "" ? "/" : props.urlPage}
              style={{width: "100%"}}
              onChange={onChange}
      >
        {menuList}
        <option value="salir">Salir</option>
      </select>
    
    </div>);
}

const NavbarMain = ({cuenta, urlPage}) => {
  
  
  const urlImgLog = "https://resec.researching.com.mx/img/logo-resH.svg";
  
  const salir = async () => {
    try {
      await signOut()
      window.location.href = '/';
    } catch (error) {
      libToast.alert(error.message);
    }
  }
  
  
  return (
    <nav id="navbar-main" className="navbar ">
      <div className="navbar-brand" style={{width: "100%"}}>
        <div className="logotopwrapper" style={{flexGrow: 0, flexShrink: 0}}>
          <img src={urlImgLog} alt="" style={{width: "160px"}}/>
        </div>
        {isMobile
          ? <MenuMobile attMenuList={attMenuList} nombre={cuenta.nombre} empresa={cuenta.empresa} onClick={salir}/>
          : <MenuDesktop attMenuList={attMenuList} nombre={cuenta.nombre} empresa={cuenta.empresa} onClick={salir}/>
        }
      
      </div>
    
    </nav>
  );
};

export default NavbarMain;